import { CommonEnums } from "../../enums/common.enums";

export class CommonHelpers {
  static isAgentRoute = (params: { path: string }) => {
    if (params.path.includes(CommonEnums.roles.agent)) return true;
    return false;
  };

  static isAgencyRoute = (params: { path: string }) => {
    if (params.path.includes(CommonEnums.roles.agency)) return true;
    return false;
  };

  static getImageUrlFromImageTool = (params: { path: string }) => {
    const baseUrl = process.env.REACT_APP_DESIGN_TOOL_ENDPOINT;
    return `${baseUrl}/design-tool/images/${params.path}`;
  };

  static isResetPasswordRoute = (params: { path: string }) => {
    if (params.path.includes("reset-password")) return true;
    return false;
  };

  static getPropertyAddress = ({
    no,
    streetName,
    city,
    state,
    country,
    postCode,
  }: {
    no: string;
    streetName: string;
    city: string;
    state: string;
    country: string;
    postCode: string;
  }) => {
    let address = "";

    address = `${streetName}, ${city}, ${state}, ${postCode}`;

    if (no) {
      address = `${no.toString().trim()} ${address}`;
    }

    return address;
  };

  /**
   * Get fullname for the agent using agent data
   * @param {PrincipalAgent} agentData
   * @returns
   */
  static getAgentName = (agentData: any) => {
    let userData: any = agentData;

    let agentName = "";

    agentName = `${userData?.principal_agent_first_name} ${userData?.principal_agent_last_name}`;

    return agentName;
  };
}
